import { NotificationBannerType } from 'Feature/V2/HbtPIRequest/components/HbtPIRequestPage/types';

export interface PortfolioCardProps {
  isLoading: boolean;
  portfolioId?: string;
  loanCount: number;
  epipProcessingStatusCode: string;
  poolPrecisionTypeCode: string;
}

export interface PortfolioNotificationConfig {
  header: string;
  subHeader: string;
  variant: NotificationBannerType;
}

export enum PortfolioWorkflowActionType {
  Revalidate = 're-validate',
  SentToCreditBureau = 'sent-to-credit-bureau',
  Cancel = 'cancel',
  Delete = 'delete'
}

export interface WorkflowExecutionResult {
  success: boolean;
  errorCode?: string;
}
